import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
const COMPACT_BREAKPOINT = 700;
const useIsCompactCalendar = () => {
    const { height } = useAppFrameDimensions();
    return height < COMPACT_BREAKPOINT;
};
export default useIsCompactCalendar;
